import { CreateVoting } from 'components/award/voting/create-voting/CreatingVoting'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { GeneralVotingContainer } from './GeneralVotingContainer'
import { NominationVotingContainer } from './NominationVotingContainer'

const GENERAL_TAB = 'general'

export const CreateVotingContainer = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [selectedCategory, setSelectedCategory] = useState(GENERAL_TAB)
    const category = searchParams.get('category') || GENERAL_TAB
    const id = searchParams.get('id')

    const { data: dataCategories } = useFetch(API_AWARD.AWARD_DETAIL, {}, { isFetching: true })
    const { fetching: getDetailAward, data: dataDetailAward } = useFetch({
        ...API_AWARD.AWARD_DETAIL,
        initPathVariable: id,
    })

    useEffect(() => {
        if (id && !dataDetailAward?.data) {
            getDetailAward()
        }
    }, [id])

    useEffect(() => {
        const findCategory = dataCategories?.data?.find((option) => option.name === category)
        if (findCategory) {
            setSelectedCategory(findCategory)
        } else {
            setSelectedCategory(GENERAL_TAB)
        }
    }, [category, dataCategories?.data])

    const optionsAwardList = useMemo(() => {
        const list = dataCategories?.data?.map((item) => item.name) || []
        list.unshift(GENERAL_TAB)
        return list
    }, [dataCategories])

    const onChangeSidebar = (item) => {
        navigate(`/awards/voting/create?category=${item}${id ? `&id=${id}` : ''}`, { replace: true })
    }

    const props = {
        options: optionsAwardList,
        activeSidebar: category || optionsAwardList[0],
        onChangeSidebar,
        content:
            category === GENERAL_TAB ? (
                <GeneralVotingContainer
                    key={id}
                    id={id}
                    data={dataDetailAward?.data}
                    onSuccessUpdate={() => getDetailAward()}
                />
            ) : (
                <NominationVotingContainer
                    key={selectedCategory?.name}
                    awardId={id}
                    data={dataDetailAward?.data}
                    onSuccessUpdate={() => getDetailAward()}
                    {...selectedCategory}
                />
            ),
    }
    return <CreateVoting {...props} />
}
